
export function encodeTerm(term) {
	term = encodeURIComponent(term);
	return term;
}